"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useRecommendationStepper = require("../../hooks/recommendation/useRecommendationStepper");
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RecommendationStepper = () => {
  const {
    steps,
    currentStep
  } = (0, _useRecommendationStepper.useRecommendationStepper)();
  const showRecommendationStepper = (0, _useLocalTheme.default)('showRecommendationStepper', true);
  if (!showRecommendationStepper) return null;
  return (steps === null || steps === void 0 ? void 0 : steps.length) === 1 ? null : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "recommendation-stepper"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.HorizontalStepper, {
    steps: steps,
    currentStep: currentStep
  })));
};
var _default = RecommendationStepper;
exports.default = _default;